import { render, staticRenderFns } from "./contact-form.vue?vue&type=template&id=7d96b412&scoped=true&"
import script from "./contact-form.vue?vue&type=script&lang=js&"
export * from "./contact-form.vue?vue&type=script&lang=js&"
import style0 from "./contact-form.vue?vue&type=style&index=0&id=7d96b412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d96b412",
  null
  
)

export default component.exports